import { z } from 'zod';
import {
  $getFiltersRequestType,
  $getPaginationResponseType,
} from '@shared/types';

export const AIConstant = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  value: z.string(),
});

export type AIConstant = z.infer<typeof AIConstant>;

export const AIConstantsResponse = $getPaginationResponseType(AIConstant);

export type AIConstantsResponse = z.infer<typeof AIConstantsResponse>;

export const GetAIConstantsParams = $getFiltersRequestType(z.object({}));

export type GetAIConstantsParams = z.infer<typeof GetAIConstantsParams>;

export const AIConstantUpdateRequest = z.object({
  code: z.string(),
  value: z.string(),
});

export type AIConstantUpdateRequest = z.infer<typeof AIConstantUpdateRequest>;
